import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3e3b180"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-top" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "top-list paperDetection" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "论文检测"),
  /*#__PURE__*/_createElementVNode("span", null, "上传PDF或Word格式论文文档，系统自动对文档进行智能化检测，可能需要稍等几分钟，请耐心等待。")
], -1))
const _hoisted_5 = { class: "paper_info" }
const _hoisted_6 = { class: "step" }
const _hoisted_7 = {
  key: 0,
  class: "start"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createElementVNode("em", null, "点击上传")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, [
  /*#__PURE__*/_createElementVNode("p", null, "只能上传一份PDF、DOCX或CAJ文件，且不超过100M"),
  /*#__PURE__*/_createElementVNode("p", { class: "lh-10" }, " (word模板仅支持DOCX文件，pdf模板仅支持PDF或CAJ文件) ")
], -1))
const _hoisted_10 = {
  key: 1,
  class: "process"
}
const _hoisted_11 = { class: "process_doing" }
const _hoisted_12 = {
  key: 0,
  class: "font-12"
}
const _hoisted_13 = { class: "detection_items" }
const _hoisted_14 = { class: "done" }
const _hoisted_15 = {
  key: 0,
  class: "success"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "检测成功", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "可在历史记录中查看结果", -1))
const _hoisted_18 = { class: "done_info" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "论文题目：", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "检测时间：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "问题数：", -1))
const _hoisted_22 = {
  key: 1,
  class: "fail"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "检测失败", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "explain" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "说明"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 1.检测依据：《华南理工大学毕业论文撰写规范》，《GB7713学位论文编写格式》，《GB7714参考文献著录规则》，《GB15834标点符号用法》，《GB15835出版物上数字用法》，《GB3100国际单位制及其应用》， 《GB3101有关量单位符号的一般原则》，《GB3102空间和时间的量和单位》。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("2.自动检测和人工评阅相比，具有自动，快捷等优点，但目前尚无法完全具备人的智能，存在误报或漏报的可能，请同学们仔细检查！ "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 3.目前平台不支持Word读写密码，请勿设置文档读写保护。 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 4.如果您的文件存在加密水印，请去除水印后上传。 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 5.如果设置了WPS文档密码，请去除。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 6.关于doc转docx的方法，请勿直接更改后缀名，正确转换步骤可参考“帮助中心->常见问题->关于正确上传.docx文件的方法” ")
  ])
], -1))
const _hoisted_25 = { class: "area" }
const _hoisted_26 = {
  key: 0,
  class: "schools"
}

import {
  paperUpload,
  getProvince,
  getUnivercity,
  getCheckTemplate,
  getCheckTtems,
} from "@/service/paperDetection/request.js";
import { getThesisDetail } from "@/service/testReport/request.js";
import { clearTimer } from "@/service/common.js";
import { ref, reactive, onMounted, watch, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import checkLoading from "@/components/Loading.vue";
import { FormInstance, FormRules } from "element-plus";
import { ElMessage, ElMessageBox } from "element-plus";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaperDetection',
  setup(__props) {

const schoolDialog = ref(false); // 选择学校弹窗
const router = useRouter();
const timer = ref();
const check_status = ref(); // 检测状态(1:成功 2:失败)
const isSuccess = ref(true); // 检测成功与否
const ruleFormRef = ref<FormInstance>();
const upload = ref();
const step = ref(0); // 当前激活步骤
const detecTing = ref(); // 当前检测项key
const fileType = ref(); // 文件类型
const thesisItem = ref([]); //检测项
const thesisItemConfig = ref([]); // 检测项配置
const schoolTemplate = ref([]); // 学校模板
const allProvince = ref([]); // 所有省份
const schools = ref([]); // 学校
const schoolName = ref(); //学校名称
const areaRadio = ref(); // 选中地区标签
const schoolRadio = ref(); // 选中学校标签
const schoolView = ref(false); // 控制学校显示/隐藏

// 论文表单信息
const form = reactive({
  title: "",
  type: "",
  schoolName: "",
  schoolCode: "",
  templateId: "",
  file: "",
});

// 检测结果
const checkData = reactive({
  title: "",
  datetime: "",
  errorCount: "",
  id: null,
  table_path: "",
  current_detection: "",
  time: "",
  templateType: "",
  checkSn: "",
});

// 表单校验规则
const rules = reactive<FormRules>({
  schoolName: [
    {
      required: true,
      message: "请选择所属学校",
      trigger: "change",
    },
  ],
  templateId: [
    {
      required: true,
      message: "请选择学校模板",
      trigger: "change",
    },
  ],
});

// 步骤条下一步
const next = async (formEl: FormInstance | undefined) => {
  upload.value.submit();
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      if (form.file == "") {
        ElMessage.warning("请上传论文文件");
        return;
      }

      const fileName = form.file["name"]
        .substring(form.file["name"].lastIndexOf(".") + 1)
        .toUpperCase();

      if (form.type != fileName) {
        ElMessage.warning("请检查文件类型与文件是否一致");
        return;
      }

      // 调用上传检测方法
      uploadDetection();
      if (step.value++ > 2) step.value = 0;
    }
  });
};

// 文件上传改变
const uploadChange = (file: { size: number; name: string }) => {
  const isTitle = form.title == "";
  const isSize = file.size / 1024 / 1024 <= 100;
  const isName =
    file.name.endsWith("pdf") ||
    file.name.endsWith("docx") ||
    file.name.endsWith("caj");
  const schoolCodeAndtemplateId =
    form.schoolName == "" || form.templateId == "";

  if (schoolCodeAndtemplateId) {
    upload.value.clearFiles();
    ElMessage.warning("请先选择学校和模板");
    return;
  }

  if (!isName) {
    upload.value.clearFiles();
    ElMessage.warning("请上传格式为PDF、DOCX或CAJ的文件");
    return;
  }

  if (!isSize) {
    upload.value.clearFiles();
    ElMessage.warning("文件大小不能超过100MB!");
    return;
  }

  form.type = file.name.substring(file.name.lastIndexOf(".") + 1).toUpperCase();
  const isFileType = fileType.value.includes(form.type);
  if (!isFileType) {
    upload.value.clearFiles();
    ElMessage.warning("此模板暂不支持此类型文件");
    return;
  }

  if (isTitle) {
    form.title = file.name
      .replace(".pdf", "")
      .replace(".docx", "")
      .replace(".caj", "");
  }
};

// 文件上传限制
const uploadExceed = () => {
  ElMessage.warning("当前限制只能上传一份文件");
};

// 文件列表移除文件
const uploadRemove = () => {
  form.title = "";
  form.type = "";
};

// 文件上传
const uploadFile = (param: { file: string }) => {
  form.file = param.file;
};

// 上传检测
const uploadDetection = async () => {
  let formData = new FormData();
  formData.append("thesis_title", form.title);
  formData.append("file_type", form.type);
  formData.append("templateId", form.templateId);
  formData.append("file", form.file);
  formData.append("schoolCode", form.schoolCode);
  const res = await paperUpload(formData);
  if (res && res.code && res.code == 200) {
    if (res.data.result == true) {
      checkData.checkSn = res.data.info.checkSn;
      checkData.title = res.data.info.title;
      checkData.datetime = moment(res.data.info.datetime)
        .utc()
        .utcOffset(0)
        .format("YYYY-MM-DD HH:mm:ss");
      timer.value = setInterval(() => {
        setTimeout(() => {
          get_thesis();
        }, 0);
      }, 5000);
    } else {
      if (res.data.msg.includes("存在未付款报告")) {
        router.push("/history");
        ElMessage.error(res.data.msg);
      } else {
        ElMessage.error(res.data.msg);
        getAbnormal();
      }
    }
  } else {
    ElMessage.error("上传失败，请重新提交");
    getAbnormal();
  }
};

// 论文检测结果
const get_thesis = async () => {
  const res = await getThesisDetail(checkData.checkSn);
  if (res && res.code && res.code == 200) {
    check_status.value = res.data.checkStatus;
    checkData.errorCount = res.data.questionNum;
    checkData.table_path = res.data.tablePath;
    detecTing.value = res.data.currentDetection;
    thesisItemConfig.value.find((item) => {
      if (item.key == res.data.currentDetection) {
        checkData.current_detection = item.label;
        checkData.time = item.time;
      }
    });
  } else {
    clearTimer(timer.value);
    getAbnormal();
  }
};

// 异常情况初始化
const getAbnormal = () => {
  step.value = 0;
  form.title = "";
  form.type = "";
  form.file = "";
  thesisItem.value = [];
};

// 查看检测报告
const viewReport = () => {
  router.push("/history");
};

// 监听检测状态
watch(
  check_status,
  (newVal) => {
    if (newVal == 1) {
      clearTimer(timer.value);
      step.value++;
    } else if (newVal == 2) {
      clearTimer(timer.value);
      step.value++;
      isSuccess.value = false;
    } else {
      // console.log(check_status.value);
    }
  },
  { immediate: true }
);

// 获取省份
const getAllProvince = async () => {
  const res = await getProvince();
  if (res && res.code && res.code == 200) {
    allProvince.value = res.data;
  }
};

// 获取学校
const getSchools = async () => {
  let params = {
    name: schoolName.value,
    province: areaRadio.value,
  };
  const res = await getUnivercity(params);
  if (res && res.code && res.code == 200) {
    schools.value = res.data;
    schoolView.value = true;
  } else {
    ElMessage.warning(res.msg);
  }
};

// 搜索学校
const searchSchool = () => {
  getSchools();
};

// 选择地区
const clickProvince = (val) => {
  areaRadio.value = val == areaRadio.value ? "" : val;
  if (areaRadio.value) getSchools();
};

// 选择学校
const schoolChange = (obj) => {
  form.schoolName = obj.name;
  form.schoolCode = obj.code;
  ruleFormRef.value.resetFields("templateId");
  schoolDialog.value = false;
  getSchoolTemplate();
};

const clearSchool = () => {
  schoolTemplate.value = [];
};
// 获取学校模板
const getSchoolTemplate = async () => {
  const res = await getCheckTemplate(form.schoolCode);
  if (res && res.code && res.code == 200) {
    schoolTemplate.value = res.data;
  }
};

// 根据学校模板获取检测项和支持文件类型
const getThesisItem = () => {
  schoolTemplate.value.forEach((item) => {
    if (item.id == form.templateId) {
      thesisItem.value = JSON.parse(item.thesisItem);
      fileType.value = item.fileType;
    }
  });
};

// 学校模板更改事件
const schoolTemplateChange = () => {
  getThesisItem();
};

// 获取检测项配置
const getCheckConfig = async () => {
  const res = await getCheckTtems();
  if (res && res.code && res.code == 200) {
    thesisItemConfig.value = res.data;
  }
};

// 格式化检测项
const formatThesisItem = (param: any) => {
  const obj = thesisItemConfig.value.find((item) => item.key == param);
  return obj.label ? obj.label : "未知";
};

onMounted(() => {
  getAllProvince();
  getCheckConfig();
});

onUnmounted(() => {
  clearTimer(timer.value);
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_cityIcon = _resolveComponent("cityIcon")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_schoolIcon = _resolveComponent("schoolIcon")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          class: "card",
          shadow: "never"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { shadow: "never" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_steps, {
                  active: step.value,
                  "align-center": "",
                  space: "410px",
                  "finish-status": "success"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_step, { title: "填写论文信息" }),
                    _createVNode(_component_el_step, { title: "进行检测" }),
                    _createVNode(_component_el_step, { title: "完成" })
                  ]),
                  _: 1
                }, 8, ["active"])
              ]),
              (step.value == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_el_form, {
                      "hide-required-asterisk": true,
                      ref_key: "ruleFormRef",
                      ref: ruleFormRef,
                      model: form,
                      rules: rules,
                      "label-width": "120px",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "所属学校",
                          prop: "schoolName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: form.schoolName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.schoolName) = $event)),
                              placeholder: "请选择所属学校",
                              onClear: clearSchool,
                              clearable: "",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (schoolDialog.value = true))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "学校模板",
                          prop: "templateId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: form.templateId,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.templateId) = $event)),
                              placeholder: "请选择学校模板",
                              clearable: "",
                              "no-data-text": "请先选择所属学校",
                              onChange: schoolTemplateChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolTemplate.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "file" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_upload, {
                              ref_key: "upload",
                              ref: upload,
                              class: "upload-demo",
                              drag: "",
                              action: "#",
                              multiple: "",
                              "auto-upload": false,
                              limit: 1,
                              "on-change": uploadChange,
                              "http-request": uploadFile,
                              "on-exceed": uploadExceed,
                              "on-remove": uploadRemove
                            }, {
                              tip: _withCtx(() => [
                                _hoisted_9
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_upload_filled)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_8
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              color: "#0054fe",
                              size: "large",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (next(ruleFormRef.value)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一步")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (step.value == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(checkLoading),
                      (checkData.current_detection != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createTextVNode(" (当前正在检测: "),
                            _createElementVNode("strong", null, _toDisplayString(checkData.current_detection), 1),
                            _createTextVNode(" ，预计需要"),
                            _createElementVNode("strong", null, _toDisplayString(checkData.time), 1),
                            _createTextVNode(") ")
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_el_space, {
                          wrap: "",
                          size: 25
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thesisItem.value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_link, {
                                key: index,
                                underline: false
                              }, {
                                default: _withCtx(() => [
                                  (index == thesisItem.value.indexOf(detecTing.value))
                                    ? (_openBlock(), _createBlock(_component_el_icon, {
                                        key: 0,
                                        size: "16",
                                        class: "is-loading"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Loading)
                                        ]),
                                        _: 1
                                      }))
                                    : (index < thesisItem.value.indexOf(detecTing.value))
                                      ? (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 1,
                                          color: "#0054fe",
                                          size: "16"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CircleCheck)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_el_icon, { key: 2 })),
                                  _createTextVNode(" " + _toDisplayString(formatThesisItem(item)), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            color: "#0054fe",
                            size: "large",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/history')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("查看历史报告")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                (step.value == 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (isSuccess.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_SuccessFilled)
                              ]),
                              _: 1
                            }),
                            _hoisted_16,
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_el_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 5 }, {
                                    default: _withCtx(() => [
                                      _hoisted_19,
                                      _hoisted_20,
                                      _hoisted_21
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 19 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(checkData.title), 1),
                                      _createElementVNode("p", null, _toDisplayString(checkData.datetime), 1),
                                      _createElementVNode("p", null, "共检测出" + _toDisplayString(checkData.errorCount) + "个问题", 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  color: "#0054fe",
                                  size: "large",
                                  onClick: viewReport
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("查看检测报告")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_WarningFilled)
                              ]),
                              _: 1
                            }),
                            _hoisted_23,
                            _createVNode(_component_el_button, {
                              color: "#0054fe",
                              size: "large",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/index')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("返回首页")
                              ]),
                              _: 1
                            })
                          ]))
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_el_card, {
                "body-style": { background: '#f8f9fb' },
                shadow: "never"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_dialog, {
          modelValue: schoolDialog.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schoolDialog).value = $event)),
          title: "选择学校",
          draggable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "mb-20" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { class: "no-wrap" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      size: "large",
                      modelValue: schoolName.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schoolName).value = $event)),
                      placeholder: "请输入学校名称，支持模糊搜索",
                      clearable: ""
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_el_button, { onClick: searchSchool }, {
                          default: _withCtx(() => [
                            _createTextVNode("搜 索")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_divider, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_text, { class: "mx-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_cityIcon)
                          ]),
                          _: 1
                        }),
                        _createTextVNode("地区")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_el_radio_group, {
                    modelValue: areaRadio.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((areaRadio).value = $event)),
                    fill: "#0054fe"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allProvince.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_radio_button, {
                          key: index,
                          label: item.value,
                          onClick: _withModifiers(($event: any) => (clickProvince(item.value)), ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode(_component_el_divider, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_text, {
                      class: "mx-1",
                      color: "#6BBAA2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_schoolIcon)
                          ]),
                          _: 1
                        }),
                        _createTextVNode("大学")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (schoolView.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(_component_el_scrollbar, { height: "120px" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: schoolRadio.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((schoolRadio).value = $event)),
                            "text-color": "#0054fe",
                            onChange: schoolChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schools.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_radio, {
                                  key: item.code,
                                  label: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})